import { generatePath } from 'react-router-dom';
import {
  ADMIN_ORGANIZATIONS_PATHS,
  ADMIN_PATH,
  ADMIN_SCHOOLS_PATHS,
  ADMIN_TAB_PATHS,
  DOSSIERS_PATH,
  OFFERINGS_PATH
} from './paths.constants';

export const DOSSIER_DETAIL_BREADCRUMBS = {
  LOADING: () => [{ target: DOSSIERS_PATH, name: 'Overzicht' }, { name: 'Dossier ophalen...' }],
  LOADED: (data) => {
    return [{ target: DOSSIERS_PATH, name: 'Overzicht' }, { name: data?.dossierNumber || 'Dossier' }];
  }
};

export const OFFERING_DETAILS_BREADCRUMBS = {
  LOADING: () => [{ target: OFFERINGS_PATH, name: 'Doe je aanvraag' }],
  LOADED: (data) => [{ target: OFFERINGS_PATH, name: 'Doe je aanvraag' }, { name: data?.title || 'Aanvraag' }]
};

export const ADMIN_BREADCRUMBS = {
  LOADED: (data = {}) => {
    const { pathname, tabs } = data;
    const currentTab = tabs?.find((t) => `${ADMIN_PATH}${t.target}` === pathname);
    return [
      { target: `${ADMIN_PATH}${Object.values(ADMIN_TAB_PATHS)[0].path}`, name: 'Beheer' },
      { name: currentTab?.name }
    ];
  }
};

export const ADMIN_ORGANIZATIONS_BREADCRUMBS = {
  LOADED: (data = {}) => {
    return [
      { target: `${ADMIN_PATH}${Object.values(ADMIN_TAB_PATHS)[0].path}`, name: 'Beheer' },
      { target: `${ADMIN_PATH}${ADMIN_TAB_PATHS.ORGANIZATIONS.path}`, name: ADMIN_TAB_PATHS.ORGANIZATIONS.name },
      {
        name: Object.values(ADMIN_ORGANIZATIONS_PATHS).find(
          (p) => p.path === `/${data.pathname.split('/').reverse()[0]}`
        ).name
      }
    ];
  }
};

// export const ADMIN_CONTACTS_BREADCRUMBS = {
//   LOADED: (data = {}) => {
//     return [
//       { target: `${ADMIN_PATH}${Object.values(ADMIN_TAB_PATHS)[0].path}`, name: 'Beheer' },
//       { target: `${ADMIN_PATH}${ADMIN_TAB_PATHS.ORGANIZATIONS.path}`, name: ADMIN_TAB_PATHS.ORGANIZATIONS.name },
//       {
//         name: Object.values(ADMIN_ORGANIZATIONS_PATHS).find(
//           (p) => p.path === `/${data.pathname.split('/').reverse()[0]}`
//         ).name
//       }
//     ];
//   }
// };

export const ADMIN_NEW_OFFERING_BREADCRUMBS = {
  LOADED: () => {
    return [
      { target: `${ADMIN_PATH}${Object.values(ADMIN_TAB_PATHS)[0].path}`, name: 'Beheer' },
      { target: `${ADMIN_PATH}${ADMIN_TAB_PATHS.OFFERING.path}`, name: ADMIN_TAB_PATHS.OFFERING.name },
      { name: 'Nieuw' }
    ];
  }
};

export const ADMIN_DETAIL_OFFERING_BREADCRUMBS = {
  LOADED: (data) => {
    return [
      { target: `${ADMIN_PATH}${Object.values(ADMIN_TAB_PATHS)[0].path}`, name: 'Beheer' },
      { target: `${ADMIN_PATH}${ADMIN_TAB_PATHS.OFFERING.path}`, name: ADMIN_TAB_PATHS.OFFERING.name },
      { name: data?.name }
    ];
  },
  LOADING: () => {
    return [
      { target: `${ADMIN_PATH}${Object.values(ADMIN_TAB_PATHS)[0].path}`, name: 'Beheer' },
      { target: `${ADMIN_PATH}${ADMIN_TAB_PATHS.OFFERING.path}`, name: ADMIN_TAB_PATHS.OFFERING.name },
      { name: 'Aanbod ophalen...' }
    ];
  }
};

export const ADMIN_SCHOOL_MANAGEMENT_BREADCRUMBS = {
  LOADING: () => [
    { target: `${ADMIN_PATH}`, name: 'Beheer' },
    { target: `${ADMIN_PATH}${ADMIN_TAB_PATHS.ORGANIZATIONS.path}`, name: ADMIN_TAB_PATHS.ORGANIZATIONS.name },
    {
      target: `${ADMIN_PATH}${ADMIN_TAB_PATHS.ORGANIZATIONS.path}${ADMIN_ORGANIZATIONS_PATHS.SCHOOLS.path}`,
      name: ADMIN_ORGANIZATIONS_PATHS.SCHOOLS.name
    },
    {
      name: 'Schoolnet ophalen...'
    }
  ],
  LOADED: (data = {}) => {
    return [
      { target: `${ADMIN_PATH}`, name: 'Beheer' },
      { target: `${ADMIN_PATH}${ADMIN_TAB_PATHS.ORGANIZATIONS.path}`, name: ADMIN_TAB_PATHS.ORGANIZATIONS.name },
      {
        target: `${ADMIN_PATH}${ADMIN_TAB_PATHS.ORGANIZATIONS.path}${ADMIN_ORGANIZATIONS_PATHS.SCHOOLS.path}`,
        name: ADMIN_ORGANIZATIONS_PATHS.SCHOOLS.name
      },
      {
        name: data?.netName
      }
    ];
  }
};

export const ADMIN_SCHOOL_COMMUNITY_BREADCRUMBS = {
  LOADING: () => [
    { target: `${ADMIN_PATH}`, name: 'Beheer' },
    { target: `${ADMIN_PATH}${ADMIN_TAB_PATHS.ORGANIZATIONS.path}`, name: ADMIN_TAB_PATHS.ORGANIZATIONS.name },
    {
      target: `${ADMIN_PATH}${ADMIN_TAB_PATHS.ORGANIZATIONS.path}${ADMIN_ORGANIZATIONS_PATHS.SCHOOLS.path}`,
      name: ADMIN_ORGANIZATIONS_PATHS.SCHOOLS.name
    },
    {
      name: 'Schoolnet ophalen...'
    },
    {
      name: 'Schoolbestuur ophalen...'
    }
  ],
  LOADED: (data = {}) => {
    return [
      { target: `${ADMIN_PATH}`, name: 'Beheer' },
      { target: `${ADMIN_PATH}${ADMIN_TAB_PATHS.ORGANIZATIONS.path}`, name: ADMIN_TAB_PATHS.ORGANIZATIONS.name },
      {
        target: `${ADMIN_PATH}${ADMIN_TAB_PATHS.ORGANIZATIONS.path}${ADMIN_ORGANIZATIONS_PATHS.SCHOOLS.path}`,
        name: ADMIN_ORGANIZATIONS_PATHS.SCHOOLS.name
      },
      {
        target: generatePath(
          `${ADMIN_PATH}${ADMIN_TAB_PATHS.ORGANIZATIONS.path}${ADMIN_ORGANIZATIONS_PATHS.SCHOOLS.path}${ADMIN_SCHOOLS_PATHS.MANAGEMENT.path}`,
          data
        ),
        name: data?.netName
      },
      {
        name: data?.managementName
      }
    ];
  }
};

export const ADMIN_SCHOOL_SCHOOLS_BREADCRUMBS = {
  LOADING: () => [
    { target: `${ADMIN_PATH}`, name: 'Beheer' },
    { target: `${ADMIN_PATH}${ADMIN_TAB_PATHS.ORGANIZATIONS.path}`, name: ADMIN_TAB_PATHS.ORGANIZATIONS.name },
    {
      target: `${ADMIN_PATH}${ADMIN_TAB_PATHS.ORGANIZATIONS.path}${ADMIN_ORGANIZATIONS_PATHS.SCHOOLS.path}`,
      name: ADMIN_ORGANIZATIONS_PATHS.SCHOOLS.name
    },
    {
      name: 'Schoolnet ophalen...'
    },
    {
      name: 'Schoolbestuur ophalen...'
    },
    {
      name: 'Scholengemeenschap ophalen...'
    }
  ],
  LOADED: (data = {}) => {
    return [
      { target: `${ADMIN_PATH}`, name: 'Beheer' },
      { target: `${ADMIN_PATH}${ADMIN_TAB_PATHS.ORGANIZATIONS.path}`, name: ADMIN_TAB_PATHS.ORGANIZATIONS.name },
      {
        target: `${ADMIN_PATH}${ADMIN_TAB_PATHS.ORGANIZATIONS.path}${ADMIN_ORGANIZATIONS_PATHS.SCHOOLS.path}`,
        name: ADMIN_ORGANIZATIONS_PATHS.SCHOOLS.name
      },
      {
        target: generatePath(
          `${ADMIN_PATH}${ADMIN_TAB_PATHS.ORGANIZATIONS.path}${ADMIN_ORGANIZATIONS_PATHS.SCHOOLS.path}${ADMIN_SCHOOLS_PATHS.MANAGEMENT.path}`,
          data
        ),
        name: data?.netName
      },
      {
        target: generatePath(
          `${ADMIN_PATH}${ADMIN_TAB_PATHS.ORGANIZATIONS.path}${ADMIN_ORGANIZATIONS_PATHS.SCHOOLS.path}${ADMIN_SCHOOLS_PATHS.COMMUNITIES.path}`,
          data
        ),
        name: data?.managementName
      },
      {
        name: data?.communityName
      }
    ];
  }
};

export const ADMIN_SCHOOL_BRANCHES_BREADCRUMBS = {
  LOADING: () => [
    { target: `${ADMIN_PATH}`, name: 'Beheer' },
    { target: `${ADMIN_PATH}${ADMIN_TAB_PATHS.ORGANIZATIONS.path}`, name: ADMIN_TAB_PATHS.ORGANIZATIONS.name },
    {
      target: `${ADMIN_PATH}${ADMIN_TAB_PATHS.ORGANIZATIONS.path}${ADMIN_ORGANIZATIONS_PATHS.SCHOOLS.path}`,
      name: ADMIN_ORGANIZATIONS_PATHS.SCHOOLS.name
    },
    {
      name: 'Schoolnet ophalen...'
    },
    {
      name: 'Schoolbestuur ophalen...'
    },
    {
      name: 'Scholengemeenschap ophalen...'
    },
    {
      name: 'School ophalen...'
    }
  ],
  LOADED: (data = {}) => {
    return [
      { target: `${ADMIN_PATH}`, name: 'Beheer' },
      { target: `${ADMIN_PATH}${ADMIN_TAB_PATHS.ORGANIZATIONS.path}`, name: ADMIN_TAB_PATHS.ORGANIZATIONS.name },
      {
        target: `${ADMIN_PATH}${ADMIN_TAB_PATHS.ORGANIZATIONS.path}${ADMIN_ORGANIZATIONS_PATHS.SCHOOLS.path}`,
        name: ADMIN_ORGANIZATIONS_PATHS.SCHOOLS.name
      },
      {
        target: generatePath(
          `${ADMIN_PATH}${ADMIN_TAB_PATHS.ORGANIZATIONS.path}${ADMIN_ORGANIZATIONS_PATHS.SCHOOLS.path}${ADMIN_SCHOOLS_PATHS.MANAGEMENT.path}`,
          data
        ),
        name: data?.netName
      },
      {
        target: generatePath(
          `${ADMIN_PATH}${ADMIN_TAB_PATHS.ORGANIZATIONS.path}${ADMIN_ORGANIZATIONS_PATHS.SCHOOLS.path}${ADMIN_SCHOOLS_PATHS.COMMUNITIES.path}`,
          data
        ),
        name: data?.managementName
      },
      {
        target: generatePath(
          `${ADMIN_PATH}${ADMIN_TAB_PATHS.ORGANIZATIONS.path}${ADMIN_ORGANIZATIONS_PATHS.SCHOOLS.path}${ADMIN_SCHOOLS_PATHS.SCHOOLS.path}`,
          data
        ),
        name: data?.communityName
      },
      { name: data?.schoolName }
    ];
  }
};

export const ADMIN_SCHOOL_AGODI_BRANCHES_BREADCRUMBS = {
  LOADING: () => [
    { target: `${ADMIN_PATH}`, name: 'Beheer' },
    { target: `${ADMIN_PATH}${ADMIN_TAB_PATHS.ORGANIZATIONS.path}`, name: ADMIN_TAB_PATHS.ORGANIZATIONS.name },
    {
      target: `${ADMIN_PATH}${ADMIN_TAB_PATHS.ORGANIZATIONS.path}${ADMIN_ORGANIZATIONS_PATHS.SCHOOLS.path}`,
      name: ADMIN_ORGANIZATIONS_PATHS.SCHOOLS.name
    },
    {
      name: 'Schoolnet ophalen...'
    },
    {
      name: 'Schoolbestuur ophalen...'
    },
    {
      name: 'Scholengemeenschap ophalen...'
    },
    {
      name: 'School ophalen...'
    },
    {
      name: 'Vestiging ophalen...'
    }
  ],
  LOADED: (data = {}) => {
    return [
      { target: `${ADMIN_PATH}`, name: 'Beheer' },
      { target: `${ADMIN_PATH}${ADMIN_TAB_PATHS.ORGANIZATIONS.path}`, name: ADMIN_TAB_PATHS.ORGANIZATIONS.name },
      {
        target: `${ADMIN_PATH}${ADMIN_TAB_PATHS.ORGANIZATIONS.path}${ADMIN_ORGANIZATIONS_PATHS.SCHOOLS.path}`,
        name: ADMIN_ORGANIZATIONS_PATHS.SCHOOLS.name
      },
      {
        target: generatePath(
          `${ADMIN_PATH}${ADMIN_TAB_PATHS.ORGANIZATIONS.path}${ADMIN_ORGANIZATIONS_PATHS.SCHOOLS.path}${ADMIN_SCHOOLS_PATHS.MANAGEMENT.path}`,
          data
        ),
        name: data?.netName
      },
      {
        target: generatePath(
          `${ADMIN_PATH}${ADMIN_TAB_PATHS.ORGANIZATIONS.path}${ADMIN_ORGANIZATIONS_PATHS.SCHOOLS.path}${ADMIN_SCHOOLS_PATHS.COMMUNITIES.path}`,
          data
        ),
        name: data?.managementName
      },
      {
        target: generatePath(
          `${ADMIN_PATH}${ADMIN_TAB_PATHS.ORGANIZATIONS.path}${ADMIN_ORGANIZATIONS_PATHS.SCHOOLS.path}${ADMIN_SCHOOLS_PATHS.SCHOOLS.path}`,
          data
        ),
        name: data?.communityName
      },
      {
        target: generatePath(
          `${ADMIN_PATH}${ADMIN_TAB_PATHS.ORGANIZATIONS.path}${ADMIN_ORGANIZATIONS_PATHS.SCHOOLS.path}${ADMIN_SCHOOLS_PATHS.BRANCHES.path}`,
          data
        ),
        name: data?.schoolName
      },
      {
        name: data?.branchName
      }
    ];
  }
};

export const ADMIN_SCHOOL_AGODI_BRANCH_BREADCRUMBS = {
  LOADING: () => [
    { target: `${ADMIN_PATH}`, name: 'Beheer' },
    { target: `${ADMIN_PATH}${ADMIN_TAB_PATHS.ORGANIZATIONS.path}`, name: ADMIN_TAB_PATHS.ORGANIZATIONS.name },
    {
      target: `${ADMIN_PATH}${ADMIN_TAB_PATHS.ORGANIZATIONS.path}${ADMIN_ORGANIZATIONS_PATHS.SCHOOLS.path}`,
      name: ADMIN_ORGANIZATIONS_PATHS.SCHOOLS.name
    },
    {
      name: 'Schoolnet ophalen...'
    },
    {
      name: 'Schoolbestuur ophalen...'
    },
    {
      name: 'Scholengemeenschap ophalen...'
    },
    {
      name: 'School ophalen...'
    },
    {
      name: 'Vestiging ophalen...'
    },
    {
      name: 'AGODI Vestiging ophalen...'
    }
  ],
  LOADED: (data = {}) => {
    return [
      { target: `${ADMIN_PATH}`, name: 'Beheer' },
      { target: `${ADMIN_PATH}${ADMIN_TAB_PATHS.ORGANIZATIONS.path}`, name: ADMIN_TAB_PATHS.ORGANIZATIONS.name },
      {
        target: `${ADMIN_PATH}${ADMIN_TAB_PATHS.ORGANIZATIONS.path}${ADMIN_ORGANIZATIONS_PATHS.SCHOOLS.path}`,
        name: ADMIN_ORGANIZATIONS_PATHS.SCHOOLS.name
      },
      {
        target: generatePath(
          `${ADMIN_PATH}${ADMIN_TAB_PATHS.ORGANIZATIONS.path}${ADMIN_ORGANIZATIONS_PATHS.SCHOOLS.path}${ADMIN_SCHOOLS_PATHS.MANAGEMENT.path}`,
          data
        ),
        name: data?.netName
      },
      {
        target: generatePath(
          `${ADMIN_PATH}${ADMIN_TAB_PATHS.ORGANIZATIONS.path}${ADMIN_ORGANIZATIONS_PATHS.SCHOOLS.path}${ADMIN_SCHOOLS_PATHS.COMMUNITIES.path}`,
          data
        ),
        name: data?.managementName
      },
      {
        target: generatePath(
          `${ADMIN_PATH}${ADMIN_TAB_PATHS.ORGANIZATIONS.path}${ADMIN_ORGANIZATIONS_PATHS.SCHOOLS.path}${ADMIN_SCHOOLS_PATHS.SCHOOLS.path}`,
          data
        ),
        name: data?.communityName
      },
      {
        target: generatePath(
          `${ADMIN_PATH}${ADMIN_TAB_PATHS.ORGANIZATIONS.path}${ADMIN_ORGANIZATIONS_PATHS.SCHOOLS.path}${ADMIN_SCHOOLS_PATHS.BRANCHES.path}`,
          data
        ),
        name: data?.schoolName
      },
      {
        target: generatePath(
          `${ADMIN_PATH}${ADMIN_TAB_PATHS.ORGANIZATIONS.path}${ADMIN_ORGANIZATIONS_PATHS.SCHOOLS.path}${ADMIN_SCHOOLS_PATHS.AGODI_BRANCHES.path}`,
          data
        ),
        name: data?.branchName
      },
      {
        name: data?.agodiBranchName
      }
    ];
  }
};
